import { useNavigate } from 'react-router-dom';
import CenteredCardTempScreen from './ui/CenteredCardTempScreen';
import Headline from './ui/Headline';
import Button from './ui/Button';
import { PurchaseSuccessMark } from './ui/PurchaseSuccessMark';
import { AppleIcon, WindowsIcon } from './ui/PlatformIcons';

// Where Stripe sends the user back after any successful checkout (single pack,
// cart, or subscription) — see functions/src/index.ts `success_url`. The pack /
// subscription only actually lands once the Stripe webhook writes it to the user
// doc, which the plugin picks up on its own; this screen just confirms the
// payment and points the user at the plugin.
function PurchaseSuccessPage() {
    const navigate = useNavigate();

    return (
        <CenteredCardTempScreen size="notice" className="relative md:w-[520px] md:min-h-[480px]">
            <button
                onClick={() => navigate('/account')}
                aria-label="Close"
                className="absolute right-5 top-5 flex h-8 w-8 items-center justify-center rounded-full border border-hairline text-ink-secondary transition-opacity hover:opacity-60"
            >
                <svg viewBox="0 0 10 10" className="h-2.5 w-2.5" fill="none" aria-hidden>
                    <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
            </button>

            <PurchaseSuccessMark />

            <Headline stacked lead="Purchase" trail="Successful." className="text-center" />

            <p className="max-w-[340px] text-sub font-bold text-copy">
                Open the Organic Electronics instrument in your DAW to access your packs
            </p>

            <div className="mt-auto flex flex-col items-center gap-3 pt-6">
                <span className="text-ui font-semibold text-card-muted-soft">Don&rsquo;t have it yet?</span>
                <div className="flex gap-2.5">
                    <Button
                        variant="primary"
                        size="md"
                        onClick={() => navigate('/download-started?platform=mac')}
                        className="gap-2"
                    >
                        <AppleIcon />
                        macOS
                    </Button>
                    <Button
                        variant="primary"
                        size="md"
                        onClick={() => navigate('/download-started?platform=windows')}
                        className="gap-2"
                    >
                        <WindowsIcon />
                        Windows
                    </Button>
                </div>
            </div>
        </CenteredCardTempScreen>
    );
}

export default PurchaseSuccessPage;
